import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { closedCubicFromBreakPoints, closedCubicFromControlPoints, openCubicFromBreakPoints, openCubicFromControlPoints, } from "@thi.ng/geom-splines";
import { TAU } from "@thi.ng/math";
import { mapcat } from "@thi.ng/transducers";
import { Cubic } from "../api/cubic";
import { arc } from "../ctors/arc";
import { cubicFromArc, cubicFromLine, cubicFromQuadratic, } from "../ctors/cubic";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
import { asPolygon } from "./as-polygon";
export const asCubic = defmulti(dispatch);
asCubic.addAll({
    [Type.ARC]: cubicFromArc,
    [Type.CIRCLE]: ($) => asCubic(arc($.pos, $.r, 0, 0, TAU, true, true)),
    [Type.CUBIC]: ($) => [$],
    [Type.GROUP]: ($) => [...mapcat(asCubic, $.children)],
    [Type.LINE]: ({ attribs, points }) => [
        cubicFromLine(points[0], points[1], Object.assign({}, attribs)),
    ],
    [Type.PATH]: ($) => [
        ...mapcat((s) => (s.geo ? asCubic(s.geo) : null), $.segments),
    ],
    [Type.POLYGON]: ($, opts = {}) => polyCubic($, opts, closedCubicFromBreakPoints, closedCubicFromControlPoints),
    [Type.POLYLINE]: ($, opts = {}) => polyCubic($, opts, openCubicFromBreakPoints, openCubicFromControlPoints),
    [Type.QUADRATIC]: ({ attribs, points }) => [
        cubicFromQuadratic(points[0], points[1], points[2], Object.assign({}, attribs)),
    ],
    [Type.RECT]: ($, opts) => asCubic(asPolygon($), opts),
});
asCubic.isa(Type.ELLIPSE, Type.CIRCLE);
// prettier-ignore
const polyCubic = ($, opts, breakPoints, controlPoints) => {
    opts = Object.assign({ breakPoints: false, scale: 1 / 3, uniform: false }, opts);
    return (opts.breakPoints
        ? breakPoints($.points, opts.scale, opts.uniform)
        : controlPoints($.points, opts.scale, opts.uniform)).map((pts) => new Cubic(pts, copyAttribs($)));
};
